<template>
  <section class="profile-container">
    <!-- Profile info -->
    <div class="profile-section rounded border border-gray-100 p-4 vl-u-bg-alt">
      <h4 class="vl-title vl-title--h4 mb-3">Mijn gegevens</h4>
      <div class="vl-form-grid vl-form-grid--is-stacked mt-2">
        <div class="vl-form-col--2-12">
          <label for="name">Voornaam</label>
        </div>
        <div class="vl-form-col--10-12">
          <input type="text" id="name" v-model="firstName" name="name" class="vl-input-field vl-input-field--block">
        </div>
        <div class="vl-form-col--2-12">
          <label for="last-name">Naam </label>
        </div>
        <div class="vl-form-col--10-12">
          <input type="text" id="last-name" v-model="lastName" name="last-name"
            class="vl-input-field vl-input-field--block">
        </div>
        <div class="vl-form-col--2-12">
          <label for="email-address">Email</label>
        </div>
        <div class="vl-form-col--10-12">
          <input type="email" v-model="userEmail" id="email-address" name="email-address"
            class="vl-input-field vl-input-field--block">
        </div>
      </div>
    </div>

    <!-- Theme toggle -->
    <div class="theme-section rounded border border-gray-100 p-4 shadow-sm vl-u-bg-alt">
      <h4 class="vl-title vl-title--h4">Thema</h4>
      <p class="text-gray-500 mb-2 mt-3">
        Kies je voorkeur voor het thema van de applicatie.
      </p>

      <div class="vl-form-grid vl-form-grid--is-stacked mt-2">
        <div class="vl-form-col--2-12">
          <label for="theme-toggle">Thema</label>
        </div>

        <div class="vl-form-col--10-12 flex items-center">
          <span class="mr-3">{{ darkModeSetting ? 'Donker' : 'Licht' }}</span>
          <label class="relative cursor-pointer scale-125 inline-block" id="theme-toggle">
            <input type="checkbox" v-model="darkModeSetting" class="sr-only peer" />
            <div class="block w-10 h-6 bg-gray-300 rounded-full peer-checked:bg-blue-500 transition"></div>
            <div class="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition peer-checked:translate-x-4">
            </div>
          </label>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProfileSettings',
  computed: {
    ...mapGetters('authentication', [
      'userName',
      'userEmail',
      'userProfile',
      'whoAmI'
    ]),

    firstName:{
      get() {
        return this.whoAmI?.firstname || '';
      }
    },

    lastName: {
      get() {
        return this.whoAmI?.lastname || '';
      }
    },

    darkModeSetting: {
      get() {
        return this.$store.state.ui.isDarkMode;
      },
      set(value) {
        this.$store.commit('ui/UPDATE_DARK_MODE', value);
      }
    }
  },

  mounted() {
    const { firstname, lastname } = this.whoAmI || {};
  }
};
</script>

<style scoped>
.profile-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.dot {
  transition: transform 0.3s ease;
}
input:checked + div {
  background-color: #4f46e5;
}
input:checked + div + .dot {
  transform: translateX(100%);
  background-color: white;
}
</style>